module.exports = __webpack_public_path__ + "img/three.c924cc78.png";